module.exports = __webpack_public_path__ + "static/media/windmill-2.ef8d45fd.jpg";